'use client';

/**
 * Провайдер кэша запросов.
 *
 * Один QueryClient на жизнь вкладки — создаётся в useState, а не в модуле:
 * модульный экземпляр в Next.js переживает переходы между пользователями
 * при dev-перезагрузке и показывает чужие данные из кэша.
 */

import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from './api/client';

function makeClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        /**
         * Ретраить 4xx бессмысленно: 401 повтором не починится, 403 и 404
         * тем более. Повторяем только сетевые сбои и 5xx, и только дважды.
         */
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export default function QueryProvider({ children }: { children: React.ReactNode }) {
  const [client] = useState(makeClient);
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
